export const environment = {
  apiUrl: 'https://petites-annonces.letrot.com',
  production: true
}
